<template>
    <div class="engineer-detail-page">
        <div class="action-sheet" v-if="modalStatus">
            <div class="cover"></div>
            <div :class="{'open':sheetStatus,'simple':!attributeType,'complex':attributeType}">
                <div class="title">
                    <img :src="goodsInfo.thumb">
                    <span>{{goodsInfo.description}}</span>
                    <img class="close" src="../assets/images/popup_close@3x.png" @click="closeSheet()">
                </div>
                <div class="sheet-content">
                    <div class="sheet-scroll" v-if="attributeType">
                        <ul class="attribute">
                            <li>
                                <span>基础检测费</span>
                                <ul class="details">
                                    <li class="active">工程师检测费¥100</li>
                                </ul>
                            </li>
                            <li v-for="(item,index) in properties" :key="item.id">
                                <span>{{item.name}}</span>
                                <ul class="details" :id="'complex'+index">
                                    <li :class="{'active':modules_values.indexOf(it.id)>-1}" v-for="it in item.values" 
                                    :key="it.id" @click="selectcomplexAttr(index,$event,it)">{{it.name}}</li>
                                </ul>
                            </li>
                        </ul>
                        <div class="desc">
                            <div class="desc-title">
                                <img src="../assets/images/global_explain@3x.png">
                                <span>标准说明</span>
                            </div>
                            <div class="text">
                                {{modules[0].property_description}}
                            </div>
                        </div>
                    </div>
                    <div class="sheet-scroll" v-if="!attributeType">
                        <div class="service-content">
                            <span class="tip">{{attributeTitle}}</span>
                            <ul class="service-category" id="simple">
                                <li :class="{'active':mid == item.id}" v-for="item in modules" 
                                :key="item.id" @click="selectSimpleAttr($event,item)">
                                    <span class="service-title">{{item.name}}</span>
                                    <div>
                                        <span>¥{{item.price}}</span>
                                        <div class="img"></div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div class="desc">
                            <div class="desc-title">
                                <img src="../assets/images/global_explain@3x.png">
                                <span>标准说明</span>
                            </div>
                            <div class="text">
                                {{description}}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="footer">
                    <div class="footer-content" >
                        <div class="invoice">
                            <div class="sheet-price">
                                <span>合计：</span><span>¥{{total}}</span>
                            </div>
                        </div>
                        <div class="buy" @click="orderNow">立即支付</div>
                    </div>
                </div>
            </div>
        </div>



        <div class="main-wrapper">
            <mt-header fixed title="工程师详情" style="background:#3189FF;color:#ffffff;">
                <mt-button icon="back" slot="left" @click="goBack"></mt-button>
            </mt-header>

            <div class="personal-info">
                <img :src="engineer.avatar_url">
                <ul>
                    <li class="info">
                        <span class="name">{{engineer.eng_name}}</span>
                        <div class="status">
                            <span v-if="engineer.status == 1"><i class="online"></i>在线</span>
                            <span v-if="engineer.status == 2"><i class="busy"></i>忙碌</span>
                            <span>从业{{engineer.career_years}}年</span>
                        </div>
                    </li>
                    <li class=data>
                        <div class="rate">
                            <span class="count">{{engineer.feedback_rate}}%</span>
                            <span>好评率</span>
                        </div>
                        <div class="num">
                            <span class="count">{{engineer.service_count}}</span>
                            <span>服务数</span>
                        </div>
                    </li>
                </ul>
            </div>

            <div class="introduction">
                <p>简介</p>
                <span>
                    {{engineer.profile}}
                </span>
            </div>

            <div class="project-wrapper">
                <p>服务项目</p>
                <ul class="project-list" :class="{'open': isOpen}">
                    <li v-for="(item,index) in related_goods" :key="index" 
                    @click="selectProject(item)"> 
                        <div class="content">
                            <img class="img" :src="item.icon">
                            <div class="text">
                                <span>{{item.title}}</span>
                                <span>{{item.desc}}</span>
                            </div>
                        </div>
                        <img v-if="gid != item.gid" class="icon" src="../assets/images/paytypenor_20x20_@3x.png">
                        <img v-if="gid === item.gid" class="icon" src="../assets/images/paytypesel_20x20_@3x.png">
                    </li>
                </ul>
                <div class="more" @click="showMore">
                    更多服务项目
                    <img v-if="!isOpen" src="../assets/images/global_down_arrow@3x.png">
                    <img v-if="isOpen" src="../assets/images/global_up_arrow@3x.png">
                </div>
            </div>

            <div class="evaluation-wrapper">
                <p>用户评价<span>（展示最近10条评论数据）</span></p>
                <ul class="evaluations">
                    <li v-for="item in comments" :key="item.id">
                        <div class="title">
                            <span>{{item.nickname}}</span>
                            <img src="../assets/images/buy_evaluate_star@3x.png">
                        </div>
                        <div class="content">
                            {{item.content}}
                        </div>
                    </li>
                </ul>
            </div>

            <div class="footer">
                <div class="footer-content" >
                    <div class="invoice">
                        <div class="consultation" @click="openQiyu" v-if="allow_chat == 1">
                            <img src="../assets/images/global_footer_consult@3x.png">
                            <span>咨询</span>
                        </div>
                        <div class="text-des" @click="sa_m_invoice">
                            <span>可开具增值税发票</span>
                            <span>（支持电子或邮寄到付）</span>
                        </div>
                    </div>
                    <div class="buy" @click="buyService()">购买服务</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import BScroll from 'better-scroll'
import { MessageBox } from 'mint-ui'

export default {

    data(){
        return{
            isOpen: false,
            allow_chat: 0,
            eng_no: '',
            engineer: {},
            related_goods: [],
            comments: [],
            gid: '',
            modalStatus: false,
            attributeType:false,
            goodsInfo: {},
            total: 0,
            modules: [],
            mid: '',
            properties: [],
            sheetStatus: false,
            modules_values: [],
            modules_tags: [],
            description: ''
        }
    },
    watch:{
    
    },
    methods:{
        goBack(){
            history.go(-1)
        },
        orderNow(){
            let tags = this.modules_tags.join('，')
            localStorage.primary_gid = this.gid
            localStorage.primary_mid = this.mid
            localStorage.primary_total = this.total
            localStorage.primary_tags = tags
            localStorage.primary_modules = this.modules_values
            localStorage.primary_eng_no = this.eng_no
            if(this.attributeType){
                if(this.validToken('confirmV3','工程师购买服务')){ 
                    this.$router.push({name:'confirmV3',query:{gid:this.gid,total:this.total,tags:tags,modules:this.modules_values,eng_no:this.eng_no}})
                }
            }else {
                if(this.validToken('confirmOrder','工程师购买服务')){ 
                    this.$router.push({name:'confirmOrder',query:{mid:this.mid,gid:this.gid,modules:this.modules_values,eng_no:this.eng_no}})
                }
            }
            
        },
        selectSimpleAttr(el,data){
            this.mid = data.id
            this.total = data.price
            this.description = data.description
        },
        selectcomplexAttr(index,el,data){
            let values = this.properties[index].values
            for(let item of values){
                let i = this.modules_values.indexOf(item.id)
                if(i!=-1){
                    this.modules_values.splice(i,1)
                    this.modules_tags.splice(i,1)
                    this.total = this.total - parseFloat(item.price)
                }
            }          
            if(this.modules_values.indexOf(data.id)==-1){
                this.modules_values.push(data.id)
                this.modules_tags.push(data.name)
                this.total = this.total + parseFloat(data.price)
            }
        },
        closeSheet(){
            let vm = this
            setTimeout(function(){
                vm.modalStatus = false
            },500)
            vm.sheetStatus = false
        },
        openSheet(){
            let vm = this
            vm.modalStatus = true
            setTimeout(function(){
                vm.sheetStatus = true
            },500)
        },
        getGoodsInfo(){
            let info = {
                api_version: window.config.api_version,
                gid: this.gid
            }
            this.$store.dispatch("getGoodsInfo",info).then((res)=>{
                let data = res.data.res.data
                let extend = data.extend


                this.goodsInfo = data.goods
                
                
                let len = data.groups[0].modules.length
                this.attributeType = len==1?true:false
                this.modules = data.groups[0].modules
                this.mid = this.modules[0].id
                if(this.attributeType){
                    this.total = this.modules[0].price
                    this.properties = this.modules[0].properties
                    for(let item of this.properties){
                        this.modules_values.push(item.values[0].id)
                        this.modules_tags.push(item.values[0].name)
                    }
                }else {
                    this.attributeTitle = data.groups[0].title
                    this.total = this.modules[0].price
                    this.description = this.modules[0].description
                }
                this.openSheet()
            })
        },
        buyService(){
            if(!this.gid){
                MessageBox('', '请选择相应的服务项目');
            }else {
                this.getGoodsInfo()
            }
        },
        selectProject(data){
            this.gid = data.gid
            this.sa_m_select_service(
                data.description,
                this.engineer.eng_name,
                this.engineer.eng_no
            )
        },
        getEngineerInfo(){
            let info = {
                eng_no: this.eng_no
            }
            this.$store.dispatch('getEngineerInfo',info).then((res)=>{
                let result = res.data
                if(result.code == 0){
                    this.engineer = result.res
                    this.related_goods = result.res.related_goods
                    this.comments = result.res.comments
                }
            })
        },
        showMore(){
            this.isOpen = !this.isOpen
        }
    },
    components:{
        MessageBox
    },
    mounted(){

    },
    created(){
        localStorage.removeItem('primary_gid')
        localStorage.removeItem('primary_mid')
        localStorage.removeItem('primary_total')
        localStorage.removeItem('primary_tags')
        localStorage.removeItem('primary_modules')
        localStorage.removeItem('primary_eng_no')

        this.eng_no = this.$route.query.eng_no
        this.gid = this.$route.query.gid
        if(this.eng_no){
            this.getEngineerInfo()
        }
        
    }
 
}
</script>

<style lang="scss">
@import '../assets/css/base.scss';
  
</style>



// WEBPACK FOOTER //
// src/components/Engineer.vue